/* ============================================================
   VIVĀRA — THE JOURNAL (source data)
   ------------------------------------------------------------
   The mementos, in the order they are shown: photographs and film
   from the release dinner and the days around it. Each entry carries its
   own pixel dimensions so the rail can reserve exact space before
   anything loads — no reflow, no layout shift.

   Every film here is silent by construction: the audio track was
   removed when the files were encoded, so there is nothing to
   unmute. The player is also given no controls.

   SHOPIFY MIGRATION → assets/vivara-journal-data.js. To change the
   set, replace the files in assets/ and edit this list; nothing
   else needs touching.
   ============================================================ */
(function () {
  "use strict";

  window.VIVARA_JOURNAL = [
    { type: "image", src: "journal-01.jpg", w: 1000, h: 1500, caption: "the invite" },
    { type: "video", src: "journal-film-01.mp4", poster: "journal-film-01-poster.jpg", w: 1280, h: 720, caption: "the evening, moving" },
    { type: "image", src: "journal-05.jpg", w: 1500, h: 844, caption: "twenty-one of us" },
    { type: "image", src: "journal-10.jpg", w: 1500, h: 1000, caption: "plating" },
    { type: "image", src: "journal-02.jpg", w: 1500, h: 1000, caption: "before anyone sat" },
    { type: "image", src: "journal-03.jpg", w: 1500, h: 844, caption: "the room" },
    { type: "image", src: "journal-04.jpg", w: 1500, h: 844, caption: "lighting up" },
    { type: "image", src: "journal-06.jpg", w: 1500, h: 999, caption: "the table, set" },
    { type: "image", src: "journal-07.jpg", w: 1500, h: 844, caption: "ground and stone" },
    { type: "image", src: "journal-08.jpg", w: 1500, h: 844, caption: "by candlelight" },
    { type: "image", src: "journal-09.jpg", w: 1500, h: 1065, caption: "first plate" },
    { type: "image", src: "journal-11.jpg", w: 1500, h: 1233, caption: "second plate" },
    { type: "image", src: "journal-12.jpg", w: 1500, h: 1000, caption: "carried through" },
    { type: "image", src: "journal-13.jpg", w: 1500, h: 1000, caption: "the bottle, at the table" },
    { type: "image", src: "journal-14.jpg", w: 1500, h: 844, caption: "nine courses" },
    { type: "image", src: "journal-15.jpg", w: 1500, h: 844, caption: "firelight" },
    { type: "image", src: "journal-16.jpg", w: 1500, h: 960, caption: "measured out" },
    { type: "image", src: "journal-17.jpg", w: 1500, h: 1000, caption: "candles down" },
    { type: "image", src: "journal-18.jpg", w: 1500, h: 999, caption: "the bottle" },
    { type: "image", src: "journal-19.jpg", w: 1500, h: 1000, caption: "long exposure" },
    { type: "video", src: "journal-film-02.mp4", poster: "journal-film-02-poster.jpg", w: 406, h: 720, caption: "held" },
    { type: "image", src: "journal-20.jpg", w: 1130, h: 1500, caption: "in hand" },
    { type: "image", src: "journal-21.jpg", w: 1500, h: 1125, caption: "the view" },
    { type: "image", src: "journal-22.jpg", w: 1320, h: 734, caption: "taking it" },
    { type: "image", src: "journal-23.jpg", w: 1500, h: 1125, caption: "the box" },
    { type: "image", src: "journal-24.jpg", w: 1125, h: 1500, caption: "somewhere else" },
    { type: "image", src: "journal-25.jpg", w: 1125, h: 1500, caption: "a street" }
  ];
})();
